import BaseModel from "./base/baseModel";
import TipoServico from "./enum/tipoServico";

export default class ServicoEntregaModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    codigo?: string = null;
    tipo: TipoServico = null;
}
